import { siteName } from "@/mocks/editorial";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative overflow-hidden pt-16"
      aria-label="品牌首屏"
    >
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-8 px-4 py-10 md:px-6 md:py-14 lg:grid-cols-12 lg:py-20">
        {/* 文本区 */}
        <div className="lg:col-span-7">
          <p className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-radio-2-line"></i>
            热点传播观察 · 持续更新
          </p>

          <h1 className="mt-6 font-heading text-[2.1rem] font-semibold leading-[1.2] text-foreground-950 md:text-6xl md:leading-[1.12]">
            一个热点，
            <br />
            是怎么“<span className="text-primary-600">爆</span>”起来的？
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            {siteName}
            聚焦事件为何会爆发、如何牵一发而动全身。我们系统拆解
            <strong className="font-medium text-foreground-900">
              波及范围、连锁反应与后续余波
            </strong>
            ，理清一场舆论震荡从发酵到沉淀的完整脉络，帮你更清醒、更理性地看待每一条热搜背后的成因。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#blast"
              className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-center text-[15px] font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              从“为何会爆”看起
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="#ripple"
              className="whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-center text-[15px] font-medium text-foreground-800 transition-colors hover:bg-secondary-100"
            >
              看波及面分层
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-3 gap-6 border-t border-background-200 pt-6">
            {[
              ["04", "扩散关键变量"],
              ["4 层", "波及圈层模型"],
              ["24h", "热度峰值窗口"],
            ].map(([n, t]) => (
              <div key={t}>
                <dt className="order-2 text-xs text-foreground-600">{t}</dt>
                <dd className="font-heading text-2xl font-semibold text-accent-700 md:text-3xl">
                  {n}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        {/* 视觉区 */}
        <div className="lg:col-span-5">
          <figure className="relative">
            <div className="overflow-hidden rounded-[2rem] border border-background-200 bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20layered%20paper%20cutouts%20and%20ripple%20concentric%20rings%20in%20warm%20terracotta%20red%2C%20ochre%20gold%20and%20cream%20tones%2C%20scattered%20small%20typographic%20marks%2C%20textured%20matte%20finish%2C%20graphic%20design%20composition%2C%20soft%20natural%20light%2C%20no%20people%20no%20text&width=1000&height=1240&seq=guabao-hero-x1&orientation=portrait"
                alt="瓜爆观察：热点涟漪波及的抽象编辑插画，同心圆从中心向外扩散的传播示意图"
                width={500}
                height={620}
                className="h-[340px] w-full object-cover object-center md:h-[520px]"
              />
            </div>
            <figcaption className="absolute -bottom-4 -left-2 flex items-center gap-2 rounded-2xl border border-background-200 bg-background-50 px-4 py-3 shadow-sm md:-left-6">
              <span className="grid h-9 w-9 place-items-center rounded-full bg-accent-500 text-background-50">
                <i className="ri-donut-chart-line"></i>
              </span>
              <span className="pr-1">
                <b className="block text-sm font-medium text-foreground-950">
                  涟漪式扩散模型
                </b>
                <span className="block text-xs text-foreground-600">
                  由内向外逐层波及
                </span>
              </span>
            </figcaption>
          </figure>
        </div>
      </div>

      {/* 底部滚动提示条 */}
      <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 md:px-6">
        <div className="flex-1 border-t border-dashed border-background-300"></div>
        <a
          href="#watch"
          className="flex items-center gap-2 whitespace-nowrap text-xs font-medium uppercase tracking-widest text-foreground-600 hover:text-primary-600"
        >
          <i className="ri-scroll-to-bottom-line"></i>
          开始梳理
        </a>
        <div className="flex-1 border-t border-dashed border-background-300"></div>
      </div>
    </section>
  );
}